<template>
  <div class="image-selector">
    <div class="selector-container">
      <!-- Thumbnails section -->
      <div class="thumbnails-section">
        <div class="thumbnails-wrapper">
          <!-- Setas desktop - TRANSPARENTES como original -->
          <button class="scroll-button up" @click="scrollThumbnails(-120)" v-if="isDesktop && showScrollButtons">
            <i class="fa fa-chevron-up"></i>
          </button>
          
          <!-- Setas mobile - TRANSPARENTES como original -->
          <button class="scroll-button left" @click="scrollThumbnails(-120)" v-if="!isDesktop && showScrollButtons">
            <i class="fa fa-chevron-left"></i>
          </button>
          
          <!-- Container de thumbnails -->
          <div class="thumbnails-container" ref="thumbnailsContainer">
            <div
              v-for="(image, index) in images"
              :key="index"
              class="thumbnail-item"
              :class="{ 'is-active': currentImage === image.url }"
              @click="setCurrentImage(image)"
            >
              <img :src="image.url" :alt="image.alt" class="thumbnail-image" />
            </div>
          </div>
          
          <button class="scroll-button down" @click="scrollThumbnails(120)" v-if="isDesktop && showScrollButtons">
            <i class="fa fa-chevron-down"></i>
          </button>
          
          <button class="scroll-button right" @click="scrollThumbnails(120)" v-if="!isDesktop && showScrollButtons">
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>
      </div>

      <!-- Main image -->
      <div class="main-image-section">
        <div class="main-image-container" @click="openModal">
          <img :src="currentImage" alt="Imagem principal do produto" class="main-image" />
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div v-if="isModalOpen" class="modal-overlay" @click="closeModal">
      <div class="modal-container">
        <img 
          :src="currentImage" 
          alt="Imagem ampliada do produto" 
          class="modal-image" 
          @click.stop
        />
        <button class="modal-close" @click="closeModal">×</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageSelector',
  data() {
    return {
      images: [
        { url: 'assets/alaka_01.jpg', alt: 'Descrição da imagem 1' },
        { url: 'assets/alaka_02.jpg', alt: 'Descrição da imagem 2' },
        { url: 'assets/alaka_03.jpg', alt: 'Descrição da imagem 3' },
        { url: 'assets/alaka_04.jpg', alt: 'Descrição da imagem 4' },
        { url: 'assets/alaka_05.jpg', alt: 'Descrição da imagem 5' },
      ],
      currentImage: '',
      isModalOpen: false,
      isDesktop: false,
      showScrollButtons: false
    }
  },
  mounted() {
    this.currentImage = this.images[0]?.url || '';
    this.checkLayout();
    window.addEventListener('resize', this.checkLayout);
    
    this.$nextTick(() => {
      this.checkScrollNeeds();
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkLayout);
  },
  methods: {
    setCurrentImage(image) {
      this.currentImage = image.url;
    },
    openModal() {
      this.isModalOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeModal() {
      this.isModalOpen = false;
      document.body.style.overflow = '';
    },
    scrollThumbnails(amount) {
      if (this.$refs.thumbnailsContainer) {
        if (this.isDesktop) {
          this.$refs.thumbnailsContainer.scrollTop += amount;
        } else {
          this.$refs.thumbnailsContainer.scrollLeft += amount;
        }
      }
    },
    
    checkScrollNeeds() {
      const container = this.$refs.thumbnailsContainer;
      if (!container || this.images.length === 0) {
        this.showScrollButtons = false;
        return;
      }
      
      const tolerance = 2;
      
      if (this.isDesktop) {
        const needsScroll = container.scrollHeight > container.clientHeight + tolerance;
        this.showScrollButtons = needsScroll;
      } else {
        const needsScroll = container.scrollWidth > container.clientWidth + tolerance;
        this.showScrollButtons = needsScroll;
      }
    },
    
    checkLayout() {
      const wasDesktop = this.isDesktop;
      this.isDesktop = window.innerWidth >= 922;
      
      if (wasDesktop !== this.isDesktop || !this.$refs.thumbnailsContainer) {
        this.$nextTick(() => {
          this.checkScrollNeeds();
        });
      }
    }
  },
  watch: {
    images: {
      handler() {
        this.$nextTick(() => {
          this.checkScrollNeeds();
        });
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.image-selector {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1rem;
  box-sizing: border-box;
}

.selector-container {
  display: flex;
  width: 100%;
  max-width: 1200px;
  gap: 2rem;
  align-items: flex-start;
}

.thumbnails-section {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.thumbnails-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.thumbnails-container {
  display: flex;
  gap: 0.8rem;
  scroll-behavior: smooth;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 5px;
}

.thumbnails-container::-webkit-scrollbar {
  display: none;
}

.thumbnails-container {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* SETAS TRANSPARENTES - DESIGN ORIGINAL */
.scroll-button {
  position: absolute;
  background: rgba(197, 195, 195, 0.5) !important;
  border: none !important; /* SEM BORDA */
  border-radius: 0;
  width: 70%;
  height: 30px;
  cursor: pointer;
  font-size: 1.2rem;
  color: #333; /* Cor simples do ícone */
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  box-shadow: none !important; /* SEM SOMBRA */
}

.scroll-button:hover {
  background: rgba(197, 195, 195, 0.253) !important;
  border: none !important;
  color: #007bff; /* Apenas muda a cor ao hover */
  transform: scale(1.1);
}

/* POSIÇÕES CORRETAS - DENTRO DOS LIMITES */
.scroll-button.up {
  top: 5px; /* DENTRO do container, não invade barra superior */
  left: 50%;
  transform: translateX(-50%);
}

.scroll-button.down {
  bottom: 5px; /* DENTRO do container */
  left: 50%;
  transform: translateX(-50%);
}

.scroll-button.left {
  left: 5px; /* DENTRO do container */
  top: 50%;
  transform: translateY(-50%);
}

.scroll-button.right {
  right: 5px; /* DENTRO do container */
  top: 50%;
  transform: translateY(-50%);
}

/* THUMBNAILS */
.thumbnail-item {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  overflow: hidden;
  border: 3px solid transparent;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #f4cf5e;
}

.thumbnail-item.is-active {
  border-color: #007bff;
}

.thumbnail-item:hover{
  border-color: #007bff;
}
.thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.main-image-section {
  flex: 1;
  display: flex;
  justify-content: center;
}

.main-image-container {
  max-width: 100%;
  cursor: pointer;
  border-radius: 5px;
  overflow: hidden;
  background: rgba(244, 207, 94, 0.6);
  padding: 5px;
  
}

.main-image {
  max-width: 100%;
  max-height: 500px;
  object-fit: contain;
}

/* MODAL */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-container {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
}

.modal-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
}

.modal-close {
  position: absolute;
  top: -40px;
  right: -40px;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  width: 40px;
  height: 40px;
}

/* === MOBILE === */
@media (max-width: 921px) {
  .image-selector {
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden; /* IMPEDE SCROLL LATERAL DA PÁGINA */
    padding: 0.5rem;
    box-sizing: border-box;
  }

  .selector-container {
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    width: 100%;
    max-width: 100%;
  }
  
  .thumbnails-section {
    width: 100%;
    max-width: 100%;
  }
  
  .thumbnails-wrapper {
    width: 100%;
    max-width: 100%;
    position: relative;
    padding: 10px 40px; /* Espaço para as setas */
    box-sizing: border-box;
  }
  
  .thumbnails-container {
    flex-direction: row;
    overflow-x: auto; /* SCROLL APENAS DENTRO DO CONTAINER */
    overflow-y: hidden;
    width: 100%;
    max-width: 100%;
    min-height: 90px;
    justify-content: flex-start; /* Alinha à esquerda para scroll */
    background: rgba(244, 207, 94, 0.6);
    padding: 10px;
    box-sizing: border-box;
    /* Garante que o scroll fique contido */
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .thumbnails-container::-webkit-scrollbar {
    display: none;
  }
  
  .thumbnail-item {
    width: 80px;
    height: 80px;
    flex-shrink: 0; /* IMPEDE QUE AS THUMBNAILS ENCOLHAM */
  }
  
  /* Setas mobile - CORRIGIDAS */
  .scroll-button {
    background: transparent !important;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    z-index: 20;
  }

  .scroll-button.left {
    left: 5px;
    top: 50%;
    transform: translateY(-50%);
  }
  
  .scroll-button.right {
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
  }
  
  .scroll-button.up, .scroll-button.down {
    display: none;
  }
  
  .main-image-section {
    width: 100%;
    max-width: 100%;
  }
  
  .main-image-container {
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
  }
  
  .main-image {
    max-height: 350px;
    width: 100%;
  }
}

/* === DESKTOP === */
@media (min-width: 922px) {
  .selector-container {
    flex-direction: row;
    align-items: flex-start;
  }
  
  .thumbnails-section {
    width: 120px;
    position: relative;
    padding: 10px 0; /* Espaço para setas não invadirem */
  }
  
  .thumbnails-container {
    flex-direction: column;
    overflow-y: auto;
    max-height: 500px;
    width: 100%;
  }
  
  .thumbnail-item {
    width: 100px;
    height: 100px;
  }
  
  .scroll-button.left, .scroll-button.right {
    display: none;
  }
  
  .main-image-section {
    max-width: 600px;
  }
}
</style>